import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Reveal, Overline } from "@/components/Reveal";
import { ArticleCard } from "@/sections/BlogSection";
import { ARTICLES } from "@/data/content";

export default function BlogPage() {
  useEffect(() => {
    document.title = "Actualités · PRIMEC2E";
  }, []);

  return (
    <div className="bg-white">
      <Header />
      <main>
        <section className="bg-[#F4F8EC] border-b border-slate-200 pt-40 pb-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
            <Overline>Actualités</Overline>
            <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-midnight">
              Le blog de la performance énergétique
            </h1>
            <p className="mt-5 text-slate-600 font-light max-w-2xl">
              Décryptages réglementaires, évolutions des CEE, aides disponibles et retours d'expérience.
            </p>
          </div>
        </section>

        <section className="bg-slate-100 py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {ARTICLES.map((a, i) => (
                <Reveal key={a.slug} delay={(i % 3) * 0.08}><ArticleCard article={a} /></Reveal>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
